var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-success",attrs:{"type":"button","disabled":""}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n  "+_vm._s(_vm.wording[0].buttons.processing)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }